module.exports = __webpack_public_path__ + "static/media/title.40d567c4.png";